import SubNav from './SubNav'

class SubNavReport extends React.Component {
  render () {
    let {user, subscriptionExpired} = this.props

    const links = [
      {
        href: '/reports/transactions',
        label: 'Transactions'
      },
      {
        href: '/reports/invoices',
        label: 'Invoices'
      },
      {
        href: '/reports/shifts',
        label: 'Shift'
      }
    ]

    return (<SubNav links={links} location={this.props.location} user={user} subscriptionExpired={subscriptionExpired} />)
  }
}

SubNavReport.propTypes = {
  location: React.PropTypes.object
}
export default SubNavReport



// WEBPACK FOOTER //
// ./app/components/SubNav/SubNavReport.js